import { render, staticRenderFns } from "./enquiryDetailCom.vue?vue&type=template&id=4736d8ba&scoped=true"
import script from "./enquiryDetailCom.vue?vue&type=script&lang=js"
export * from "./enquiryDetailCom.vue?vue&type=script&lang=js"
import style0 from "./enquiryDetailCom.vue?vue&type=style&index=0&id=4736d8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736d8ba",
  null
  
)

export default component.exports